import React, { Fragment, createContext } from 'react';
import PropTypes from 'prop-types';

const DocumentContext = createContext({});

export default DocumentContext;

const newContext = (repeatedHeader, pageHeight) => {
  const context = { yPos: 0, repeatedHeader };
  context.increment = (n) => {
    if (typeof n === 'number') context.yPos += n;
  };
  context.reset = () => {
    context.yPos = 0;
  };
  context.canFit = ({ height }) => height === undefined || height + context.yPos <= pageHeight;
  return context;
};

const detached = {
  increment: () => {},
  canFit: () => true,
};

const Detached = ({ children, repeatedHeader, reset }) => (
  <DocumentContext.Provider
    value={Object.assign(detached, { repeatedHeader, reset })}
  >
    {children}
  </DocumentContext.Provider>
);

Detached.propTypes = {
  children: PropTypes.node,
  repeatedHeader: PropTypes.node.isRequired,
  reset: PropTypes.func.isRequired,
};

Detached.defaultProps = {
  children: <Fragment />,
};

export { newContext, Detached };
